import XLSX from "xlsx-style"
import {saveAs} from "file-saver"

import {Log, LogItem} from "./parseResult"
import Cell = XlsxStyle.Cell
import Worksheet = XlsxStyle.Worksheet
import CellStyle = XlsxStyle.CellStyle;

const isCell = (object: any): object is XlsxStyle.Cell => (typeof object === "object") && ("v" in object)

function sheet_from_array_of_arrays(
    data: (number | boolean | string | Date | XlsxStyle.Cell)[][],
    formats: string[] = [],
    startRow: number = 0
): Worksheet {
    let ws: Worksheet = {};
    let range: XlsxStyle.Range = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    }

    for (let R = startRow; R !== data.length; ++R) {
        for (let C = 0; C !== data[R].length; ++C) {
            if (range.s.r > R) {
                range.s.r = R
            }
            if (range.s.c > C) {
                range.s.c = C
            }
            if (range.e.r < R) {
                range.e.r = R
            }
            if (range.e.c < C) {
                range.e.c = C
            }

            const value = data[R][C]

            if ((value === undefined) || (value === null)) {
                continue
            }

            let cell: XlsxStyle.Cell

            if (isCell(value)) {
                cell = value
            } else {
                cell = {
                    v: value,
                }

                let s: CellStyle = {}

                if (typeof value === "number") {
                    cell.t = "n"
                }  else if (typeof value === "boolean") {
                    cell.t = "b"
                } else if (value instanceof Date) {
                    cell.t = "n";

                    s.numFmt = XLSX.SSF._table[14]
                    cell.v = (value.valueOf() - (new Date(1899, 11, 29, 23)).valueOf()) / (24 * 60 * 60 * 1000)
                } else {
                    cell.t = "s"
                }

                s.numFmt = formats[C] || s.numFmt

                cell.s = s
            }

            const cell_ref = XLSX.utils.encode_cell({c: C, r: R});

            ws[cell_ref] = cell;
        }
    }

    if (range.s.c < 10000000) {
        ws["!ref"] = XLSX.utils.encode_range(range)
    }

    return ws;
}

function s2ab(s) {
    const buf = new ArrayBuffer(s.length)
    let view = new Uint8Array(buf)

    for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF
    }

    return buf;
}

export const exportXlsx = (log: Log) => {
    let wb: XlsxStyle.Workbook = {
        SheetNames: [],
        Sheets: {},
    }

    const sheetName = "Лента новостей"
    let ws = sheet_from_array_of_arrays(
        [
            <(Date | string | Cell)[]>["time", "from", "message"]
                .map((v): Cell => ({v, s: {font: {bold: true}}}))
        ]
            .concat(log.map(({from, message, time}: LogItem) => [time, from, message]).toArray()),
        ["hh:mm dd.mm.yy"]
    )
    ws["!cols"] = [12.33].map(wch => ({wch}))

    wb.SheetNames.push(sheetName)
    wb.Sheets[sheetName] = ws

    XLSX.write(wb, {bookType: "xlsx", bookSST: true, type: "binary"})

    const wbout = XLSX.write(wb, {bookType: "xlsx", bookSST: true, type: "binary"})
    const zip = new JSZip()

    zip.load(wbout)
    zip.file("xl/worksheets/sheet1.xml", zip.file("xl/worksheets/sheet1.xml").asText().replace("</worksheet>", `<autoFilter ref="${XLSX.utils.encode_range({c: 0, r: 0}, {c: 2, r: 0})}"/></worksheet>`))

    saveAs(new Blob([s2ab(zip.generate({type: "string"}))], {type: "application/octet-stream"}), "Лента новостей.xlsx")
}
